import { render, staticRenderFns } from "./KStartsOrganizerEditForm.vue?vue&type=template&id=893b68ca&"
import script from "./KStartsOrganizerEditForm.vue?vue&type=script&lang=js&"
export * from "./KStartsOrganizerEditForm.vue?vue&type=script&lang=js&"
import style0 from "./KStartsOrganizerEditForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports